import Tabs from '../../components/Tabs/Tabs'
import { categoriesTabs } from './categoryTabs'

export const Categories = () => {
	return (
		<Tabs
			tabs={categoriesTabs}
		/>
	)
}